import { appAxiosInstance } from '@/config/axios';

import { transformKeysSnakeToCamelCase } from '@/utils/transformation';

import {
	AddUserToWorkspaceRequest,
	AddUserToWorkspaceResponse,
	ChangeUserRoleRequest,
	CreateWorkspacePayload,
	CreateWorkspaceResponse,
	RemoveUserFromWorkspaceRequest,
	UpdateWorkspacePreferencesPayload,
	UpdateWorkspacePreferencesResponse,
	UpdateWorkspaceDiscoverabilityPayload,
	UpdateWorkspaceDiscoverabilityResponse,
	UpdateWorkspaceImageResponse,
	UpdateWorkspaceNamePayload,
} from '../types/workspace-types';

export const createWorkspace = async (payload: CreateWorkspacePayload = {}) => {
	const response = await appAxiosInstance.post(`/settings/create-workspace`, payload);
	return transformKeysSnakeToCamelCase(response.data) as unknown as CreateWorkspaceResponse;
};

export const addUserToWorkspace = async (payload: AddUserToWorkspaceRequest) => {
	const response = await appAxiosInstance.post(`/settings/add-user-to-workspace`, payload);
	return transformKeysSnakeToCamelCase(response.data) as unknown as AddUserToWorkspaceResponse;
};

export const removeUserFromWorkspace = async (payload: RemoveUserFromWorkspaceRequest) => {
	const response = await appAxiosInstance.post(`/settings/remove-user-from-workspace`, payload);
	return response.data;
};

export const updateWorkspaceImage = async (
	payload: FormData
): Promise<UpdateWorkspaceImageResponse> => {
	const response = await appAxiosInstance.post(`/settings/update-image-for-workspace`, payload);

	return transformKeysSnakeToCamelCase(response.data) as unknown as UpdateWorkspaceImageResponse;
};

export const updateWorkspaceName = async (payload: UpdateWorkspaceNamePayload): Promise<string> => {
	const response = await appAxiosInstance.post(`/settings/update-name-for-workspace`, payload);

	return response.data as string;
};

export const changeUserRole = async (payload: ChangeUserRoleRequest): Promise<void> => {
	const response = await appAxiosInstance.post(`/settings/change-user-role`, payload);
	return response.data;
};

export const updateWorkspaceDiscoverability = async (
	payload: UpdateWorkspaceDiscoverabilityPayload
): Promise<UpdateWorkspaceDiscoverabilityResponse> => {
	const response = await appAxiosInstance.post(
		`/settings/update-page-discoverability`,
		payload
	);
	return transformKeysSnakeToCamelCase(
		response.data
	) as unknown as UpdateWorkspaceDiscoverabilityResponse;
};

export const updateWorkspacePreferences = async (
	payload: UpdateWorkspacePreferencesPayload
): Promise<UpdateWorkspacePreferencesResponse> => {
	const response = await appAxiosInstance.post(`/settings/update-workspace-preferences`, payload);
	return transformKeysSnakeToCamelCase(
		response.data
	) as unknown as UpdateWorkspacePreferencesResponse;
};
